import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';


import { lookupStatusPropType } from '../../../propTypes';


const propTypes = exact({
  item: PropTypes.shape({
    lookupStatus: lookupStatusPropType.isRequired,
    name: PropTypes.string.isRequired,
  }),
});


/*
* Temporary component to be used while the lookup feature is being rolled out to users.
 */
const CompatLookupResultListItem = (props) => {
  const { item: { name } } = props;

  return (
    <div>
      { name }
    </div>
  );
};


CompatLookupResultListItem.propTypes = propTypes;


export default CompatLookupResultListItem;
